export default __webpack_public_path__ + "static/2-00827991ca70348ffb9a74d864d14f9a.jpg";